import HeadingWithHighlight from "@/components/heading-with-highlight";
import { Accordion } from "@/components/ui/accordion";

import FaqItem, { type FaqType } from "./faq-item";

export type { FaqType } from "./faq-item";

interface FaqProps {
  items: FaqType[];
  title?: string;
}

export default function Faq({
  items,
  title = "**Frequently** asked questions",
}: FaqProps) {
  return (
    <>
      <HeadingWithHighlight title={title} />
      <Accordion className="mt-10 md:mt-[50px]" type="multiple">
        {items.map((item) => (
          <FaqItem key={item.id} {...item} />
        ))}
      </Accordion>
    </>
  );
}
